import '@assets/scss/index.scss';
import '../style.scss';

import React from 'react';
import { Spin } from 'antd';
import parse from 'html-react-parser';
import { PlaceIcon } from '@assets/icons/map/Place';
import { Photo } from '@project/API/resources/news';
import { INewsCategories } from '@project/store/News/types';
import { NewsCategoryLoader } from './CategoryView';
import { NewsCategoryErrorView } from './CategoriesLoaderView';
import PhotoCarousel from '@project/components/PhotoCarousel';

export interface InfoNewsProps {
  categories: INewsCategories;
  description: string;
  address: string;
  link: string;
  photos: Photo[];
  dateStart: string;
  dateEnd: string;
  categoryId: number | null;
}

export const InfoNews: React.FC<InfoNewsProps> = ({
  categories,
  description,
  link,
  photos,
  dateStart,
  categoryId,
  address,
}) => {
  return (
    <div
      style={{
        overflowX: 'hidden',
      }}
    >
      {photos.length > 0 && (
        <PhotoCarousel items={photos} className={'img-carousel'} autoplay />
      )}

      <div className="news-description ql-editor">{parse(description)}</div>
      <br />
      <p className={'news-info-row'}>
        <b>Источник: </b>
        <a href={link} target="_blank">
          {link}
        </a>
      </p>

      <NewsCategoryLoader
        categoryId={categoryId}
        controller={categories}
        renderCategory={(value) => {
          return (
            <p className="news-info-row">
              <b>Раздел: </b>

              {value || '-'}
            </p>
          );
        }}
        renderLoader={() => <Spin />}
        renderError={() => <NewsCategoryErrorView controller={categories} />}
      />

      <p className={'news-info-row'}>
        <PlaceIcon />
        <b>Адрес проведения: </b> {address || '-'}
      </p>
      <br />
      <p className={'news-info-row'}>
        {new Date(dateStart).toLocaleDateString()}
      </p>
    </div>
  );
};
